import styled from 'styled-components'
const CustomerNoteWrapper = styled.div`

  .pagination {
    text-align: center;
  }

  .gray-topic {
    color: ${(props) => props.theme.tokens.textMuted};
  }

  .order_number {
    color: ${(props) => props.theme.tokens.danger};
    float: right;
  }
  `

export default CustomerNoteWrapper